













import Vue from 'vue';

export default Vue.extend({
  name: 'ExtraMobileMenu',

  props: {
    extraShow: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  watch: {
    extraShow(newValue) {
      this.show = newValue;
    },
  },

  data() {
    return {
      show: false,
    };
  },
});
